// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"fd81978f","639":"63b9a069","787":"f8743582","859":"bd9abbc5"}[chunkId] + ".chunk.js";
};